
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  LinearProgress,
  Chip,
  Avatar,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SchoolIcon from '@mui/icons-material/School';
import { useTraining } from '../../context/TrainingContext';
import { useAppTheme } from '../../context/ThemeContext';
import { useEffect } from 'react';

const TrainingList = () => {
    
  const { modules, getTrainingModules } = useTraining();
  const navigate = useNavigate();
  const { mode } = useAppTheme();

  useEffect(() => {

    getTrainingModules();
  },[])

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={0.5}>
        Training Modules
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Complete all modules to finish your training programme
      </Typography>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ borderRadius: 1, border: '1px solid rgba(0,0,0,0.06)',mt: 1 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#d4daf8ff' }}>
              <TableCell sx={{ fontWeight: 700, color: '#1a237e' }}>S.No.</TableCell>
              <TableCell sx={{ fontWeight: 700, color: '#1a237e' }}>Module Name</TableCell>
              <TableCell sx={{ fontWeight: 700, color: '#1a237e' }}>Progress</TableCell>
              <TableCell sx={{ fontWeight: 700, color: '#1a237e' }}>Status</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700, color: '#1a237e' }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modules?.trainings?.map((mod, idx) => {
              const percentage = mod?.duration_minutes
                ? Math.min(
                    100,
                    Math.round(
                      (mod.completion_minutes / mod.duration_minutes) * 100
                    )
                  )
                : 0;
              return (
                <TableRow
                  sx={{
                    transition: "background 0.15s",
                    "&:hover": {
                      bgcolor: mode === "dark"
                        ? "rgba(255,255,255,0.08)"
                        : "#f8f9ff",
                    },
                  }}
                >
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar sx={{ width: 36, height: 36, bgcolor: '#1a237e' }}>
                        <SchoolIcon sx={{ fontSize: 18 }} />
                      </Avatar>
                      <Typography variant="body2" fontWeight={600}>
                        {mod.module_name}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ minWidth: 130 }}>
                    <Box>
                      <Typography
                        variant="caption"
                        fontWeight={700}
                        color={percentage >= 95 ? "#2e7d32" : "#1a237e"}
                      >
                        {percentage}%
                      </Typography>

                      <LinearProgress
                        variant="determinate"
                        value={percentage}
                        sx={{
                          height: 6,
                          borderRadius: 3,
                          mt: 0.5,
                          bgcolor: "rgba(26,35,126,0.08)",
                          "& .MuiLinearProgress-bar": {
                            borderRadius: 3,
                            bgcolor: percentage >= 95 ? "#2e7d32" : "#1a237e",
                          },
                        }}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                   <Chip
                    label={mod?.completion_status}
                    size="small"
                    color={
                      mod?.completion_status === "Completed"
                        ? "success"
                        : mod?.completion_status === "In Progress"
                        ? "warning"
                        : "default"
                    }
                    variant={
                      mod?.completion_status === "Not Started"
                        ? "outlined"
                        : "filled"
                    }
                  />
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="View Module">
                      <IconButton
                        onClick={() => navigate(`/app/training/${mod.id}`)}
                        sx={{
                          color: '#1a237e',
                          bgcolor: 'rgba(26,35,126,0.06)',
                          '&:hover': { bgcolor: 'rgba(26,35,126,0.14)' },
                        }}
                        size="small"
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TrainingList;
